import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
  })
], -1)
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
  })
], -1)




export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalLink',
  props: {
  label: {
    type: String,
    required: true,
  },
  href: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
    default: "button",
  },
  capitalize: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.type === 'button')
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: __props.href,
          target: "_blank",
          class: _normalizeClass(`flex items-center h-10 px-3 py-2 space-x-2 font-normal text-white ${__props.capitalize ? 'capitalize' : ''} transition ease-in border rounded bg-primary active:bg-blue-600 hover:bg-blue-600 border-primary focus:outline-black px-0 focus:shadow-outline-purple duration-50 w-fit`)
        }, [
          _createElementVNode("span", null, _toDisplayString(__props.label), 1),
          _hoisted_2
        ], 10, _hoisted_1))
      : _createCommentVNode("", true),
    (__props.type === 'text')
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: __props.href,
          target: "_blank",
          class: _normalizeClass(`flex items-center space-x-2 font-normal text-blue-500 ${__props.capitalize ? 'capitalize' : ''} transition ease-in duration-50 w-fit focus:outline-black px-0`)
        }, [
          _createElementVNode("span", null, _toDisplayString(__props.label), 1),
          _hoisted_4
        ], 10, _hoisted_3))
      : _createCommentVNode("", true)
  ], 64))
}
}

})